import globalActions from '@/actions'
const state = {
	visable: true,
	fixed: true,
	subSidebarVisable: true,
}
const mutations = {
	fixed(){
		state.fixed = true
		state.visable = true
		globalActions.setGlobalState({
			sidebar: state
		});
	},
	float(){
		state.fixed = false
		state.visable = false
		globalActions.setGlobalState({
			sidebar: state
		});
	},
	hide() {
		state.visable = false
		globalActions.setGlobalState({
			sidebar: state
		});
	},
	toggleVisable() {
		state.visable = !state.visable
		globalActions.setGlobalState({
			sidebar: state
		});
	},
	toggleSubSidebarVisable(state) {
		state.subSidebarVisable = !state.subSidebarVisable
		globalActions.setGlobalState({
			sidebar: state
		});
	}
}

const actions = {}

export default {
	namespaced: true,
	mutations,
	state,
	actions
}